module.exports = __webpack_public_path__ + "static/media/pagination-previous.925693f5.svg";